// extracted by mini-css-extract-plugin
var _1 = "BoardActionsPopup_count__bIi+J";
var _2 = "BoardActionsPopup_icon__DSdGb";
export { _1 as "count", _2 as "icon" }
